export default __webpack_public_path__ + "static/media/program_slide001.47faad27.png";